module.exports = __webpack_public_path__ + "img/img-5@2x.641e483a.png";